import { EntityInterface } from 'common/types/entities/EntityInterface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BorderType, PaddingType } from 'common/types/styleTypes'
import { FieldInterface } from 'common/types/entities/field-interface'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export enum FormElementTypeEnum {
  Field = 'field',
  Checkbox = 'checkbox',
  SubmitButton = 'submit_button',
}

export interface FormFieldInterface
  extends Pick<
    FieldInterface,
    'id' | 'htmlAttrId' | 'placeholder' | 'optional' | 'iconClassName'
  > {
  elementType: FormElementTypeEnum.Field
  slug: ContactSlugEnum
}

export interface FormCheckboxInterface
  extends Pick<
    CheckboxInterface,
    | 'id'
    | 'htmlAttrId'
    | 'content'
    | 'errorText'
    | 'optional'
    | 'color'
    | 'mobileColor'
  > {
  elementType: FormElementTypeEnum.Checkbox
}

export interface FormSubmitButtonInterface
  extends Pick<
    ButtonInterface,
    | 'id'
    | 'htmlAttrId'
    | 'text'
    | 'subText'
    | 'iconClassNameBefore'
    | 'iconClassNameAfter'
  > {
  elementType: FormElementTypeEnum.SubmitButton
}

export type FormElementInterface =
  | FormFieldInterface
  | FormCheckboxInterface
  | FormSubmitButtonInterface

export enum FormLayoutEnum {
  OneColumn = 'one_column',
  TwoColumns = 'two_columns',
}

interface FormActionInterface
  extends Pick<
    ButtonInterface,
    | 'redirectionType'
    | 'urlRedirect'
    | 'optInSuccessText'
    | 'optInSuccessTextColor'
  > {
  doubleOptIn: boolean
}

export interface FormInterface extends EntityInterface {
  type: EntityTypeEnum.Form
  layout: FormLayoutEnum
  elements: Array<FormElementInterface>
  action: FormActionInterface
  border: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  padding: PaddingType
  mobilePadding?: PaddingType
  backgroundColor?: string
  mobileBackgroundColor?: string
}
